import React, { ReactNode } from 'react';

import { Box, SxProps } from '@mui/material';

interface Props {
  children?: ReactNode;
  sx?: SxProps;
  onMouseMove?: React.MouseEventHandler<HTMLDivElement>;
}

const SlideWrapper = ({ children, sx, onMouseMove }: Props) => (
  <Box
    onMouseMove={onMouseMove}
    sx={{
      backgroundSize: 'cover',
      px: { xs: '32px', md: '144px' },
      height: '100%',
      mb: 40,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default SlideWrapper;
